window.wxapp_id = 10001;


// WEBPACK FOOTER //
// ./src/global.js